import { isCommsEqual } from "features/AutomatedCommunication/modules/CommsSettingsModal/utils/CommsSettingsModal.utils";
import { MASTER_CONTROLS_FORM_KEYS } from "../../../constants/MasterControls.constants";

export const isCategoryCommsEqual = (old, current) =>
  isCommsEqual(
    old?.[MASTER_CONTROLS_FORM_KEYS.enabled_communication_mediums],
    current?.[MASTER_CONTROLS_FORM_KEYS.enabled_communication_mediums]
  );
